import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { RecommendedModule } from '../recommended/recommended.module';
import { DocumentsComponent } from './documents.component';

@NgModule({
    imports: [
        CommonModule,
        LazyViewModule,
        RecommendedModule
    ],
    declarations: [
        DocumentsComponent
    ],
    exports: [
        DocumentsComponent
    ]
})
export class DocumentsModule {
}
